import { Gql } from '@fiverr-private/dynamic_matching';
import { DynamicSection } from '@fiverr-private/ai_brief';
import { useBriefCreationContext } from '../context/BriefCreationContext';
import { BriefNeedType, BudgetSectionContent, NEED_TYPE_SECTION_ID } from '../components';
import { convertDollarToCents } from '../utils';
import { BudgetAndTimelineContent } from '../components/Sections/BudgetAndTimeline/utils';

export const useGetCurrentFlow = ():
    | Gql.DmMatchCandidateCreationFlow.Auction
    | Gql.DmMatchCandidateCreationFlow.BuyerInvite
    | null => {
    const { brief, briefClassification, inJpHighSpendExperience } = useBriefCreationContext();

    if (inJpHighSpendExperience) {
        return Gql.DmMatchCandidateCreationFlow.Auction;
    }

    if (!brief || !briefClassification) {
        return null;
    }

    const budgetSection = brief.sections.find(
        (section) => section.id === 'budget' || section.id === 'budget_and_timeline'
    );
    const { budgetInCents, pricingType } = (budgetSection?.content || {}) as
        | BudgetSectionContent
        | BudgetAndTimelineContent;

    const isHourlyPricing = pricingType === Gql.BriefPricingType.Hourly;

    const needTypeSection = brief?.sections?.find((section) => section.id === NEED_TYPE_SECTION_ID) as DynamicSection;
    const needType = (needTypeSection?.content as BriefNeedType)?.needType;
    const isOngoingNeed = needType === Gql.DmBriefNeedType.Ongoing;

    if (isHourlyPricing || isOngoingNeed) {
        return Gql.DmMatchCandidateCreationFlow.Auction;
    }

    const recommendedBudget = briefClassification?.static_data?.budget?.min;
    const hasRecommendedBudget = !!recommendedBudget;
    const hasBudget = !!budgetInCents;
    const meetsMinimumBudget =
        hasBudget && hasRecommendedBudget && budgetInCents >= convertDollarToCents(recommendedBudget);

    if (!hasBudget || !hasRecommendedBudget) {
        return null;
    }

    return meetsMinimumBudget ? Gql.DmMatchCandidateCreationFlow.Auction : Gql.DmMatchCandidateCreationFlow.BuyerInvite;
};
